import React from 'react';
import { Card, Row, Form, Button, Select, Col, Typography, Input, message, Tooltip, Icon, Radio, Spin, Image, Steps, Divider  } from "antd"
import { IdcardOutlined  } from '@ant-design/icons';
import { API, Auth } from "aws-amplify"
import { connect } from "react-redux"
import { withRouter } from 'react-router-dom'
import PagoFacil from '../../Images/PagoFacil.png'
import RapiPago from '../../Images/RapiPago.png'
import Checkout from '../../Images/Checkout.png'
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import RadioButton from "antd/lib/radio/radioButton";
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import mpago from '../../Images/mpago.png'
import {ConsoleView, isMobile} from 'react-device-detect';

const { Step } = Steps;
const { Option } = Select;
const { Paragraph, Text } = Typography;
var interval = null;
var count = 0
            

class MercadoPago extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            documentTypes: [],
            loading: true,
            paymentRejected: false,
            loadingPlans: true,
            issuerOptions: [],
            doSubmit: false,
            issuerRequired: false,
            paymentResponse: {},
            docMinLength: 7,
            mpResponse: {},
            docMaxLength: 8,
            id: '',
            plan: {},
            cardHolder: {
                name: '',
                identification: {
                    type: '',
                    value: ''
                }
            },
            rebillSdk:{
                width: '',
                iframeWidth: '',
                workerImg: '',
                cardHeight: '',
            },
            loadingSdk: false,
            formData: {
                cardholderName: '',
                email: '',
                docType: 'DNI',
                docNumber: '',
                cardExpirationMonth: '',
                cardExpirationYear: '',
                cardNumber: '',
                securityCode: '',
                issuer: '', //Bco emisor
                insstallments: '1', //cuotas
                transactionAmount: '',
                paymentMethodId: '',
                description: '',
                paymentMethod: '',
            },
            card: {
                name: 'token',
                type: 'hidden',
                value: ''
            },
            personalId : false,
            rebObj: null
        }
        this.getIssuers = this.getIssuers.bind(this);
        this.setIssuers = this.setIssuers.bind(this);
        this.getCardToken = this.getCardToken.bind(this);
        this.setCardTokenAndPay = this.setCardTokenAndPay.bind(this)
        this.guessPaymentMethod = this.guessPaymentMethod.bind(this);
        this.setPaymentMethod = this.setPaymentMethod.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    next(){
        const step = this.state.current
                this.setState({ current : step + 1 })
    }

    prev(){
        const step = this.state.current
        this.setState({ current : step - 1})
    }

    handleSuccess(response){
        if (response.failedTransaction === null){
            if (response.pendingTransaction !== null){
                this.props.history.push({pathname: "/checkout/pending", state: {isStepUser : this.props.stepsUser , resp: response, payment: response.pendingTransaction.id}})    
            }else{
                Auth.currentSession()
                .then(response => {
                    API.post(
                        'test',
                        '/root/users/me/processPayment',
                        {
                            headers: {
                                Authorization: response.getIdToken().getJwtToken()
                            }
                        }
                    )
                    .then(response => {})
                    .catch(err => {
                        message.error('Error actualizando usuario')
                        console.log(err)
                    })
                })
                this.props.history.push({pathname: "/checkout/success", state: {isStepUser : this.props.stepsUser , resp: response}})
            }
        }else{
            let errorMessage = ""
            switch (response.failedTransaction.paidBags[0].payment.errorMessage) {
                case 'cc_rejected_bad_filled_card_number':
                    errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                    break;
                case 'cc_rejected_bad_filled_date':
                    errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                    break;
                case 'cc_rejected_bad_filled_other':
                    errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                    break;
                case 'cc_rejected_bad_filled_security_code':
                    errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                    break;
                case 'cc_rejected_blacklist':
                    errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                    break;
                case 'cc_rejected_call_for_authorize':
                    errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                    break;
                case 'cc_rejected_high_risk':
                    errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                    break;
                case 'cc_rejected_insufficient_amount':
                    errorMessage = 'Tu tarjeta no tiene fondos suficientes. Por favor intentá con otra tarjeta.'
                    break;
                case 'cc_rejected_other_reason':
                    errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                    break;
                default:
                    errorMessage = 'Tu pago fue rechazado. Por favor intentá con otro medio de pago.'
                    break;
            }
            // console.log("Error Rebill")
            // console.log(errorMessage)
            this.props.history.push({pathname: "/checkout/error", state: {isStepUser : this.props.stepsUser , errorMessage: errorMessage}})
        
        }
    }

    handleError(response){
        // console.log("Respuesta Error Rebill")
        // console.log(response)
        this.props.history.push({pathname: "/checkout/error", state: {isStepUser : this.props.stepsUser , errorMessage: response}})
    }
    
    async scriptLoaded(formData){
                
        const initialization = {
            organization_id: "54f10761-538e-4a0d-b3b1-6be030d4c177",
            api_url: "https://api.rebill.to/v2"
        }
        // 
        const rebill_checkout = new window.Rebill.PhantomSDK(initialization);
                // 
        const rebillCustomer = {
            firstName: this.props.login.user_data.nombre ? this.props.login.user_data.nombre : " ",
            lastName: this.props.login.user_data.apellido ? this.props.login.user_data.apellido : " ",
            email: this.props.login.user_data.email,
        }
        // 
        const cardHolder = {
            name: formData['cardholderName'],
            identification: {
                type: formData['docType'],
                value: formData['docNumber'],
                },
            }
        //
        const transaction = {
            prices: [
            {
                id: this.props.match.params.id,
                quantity: 1,
            },
            ],
        }
        // 
        rebill_checkout.setCustomer(rebillCustomer);
        rebill_checkout.setCardHolder(cardHolder)
        await rebill_checkout.setTransaction(transaction)
        rebill_checkout.setCallbacks({
                onSuccess: (response) => this.handleSuccess(response),
                onError: (error) => this.handleError(error),
            });
        rebill_checkout.setText({
                card_number: 'Número de Tarjeta',
                pay_button: 'Confirmar Pago',
                error_messages: {
                    emptyCardNumber: 'Ingresá el número de Tarjeta',
                    invalidCardNumber: 'El número de tarjeta es inválido',
                    emptyExpiryDate: 'Ingresá fecha de vencimiento',
                    monthOutOfRange: 'La fecha de vencimiento debe ser un número entre 01 y 12',
                    yearOutOfRange: 'La fecha de vencimiento no es válida',
                    dateOutOfRange: 'La fecha de vencimiento no es válida',
                    invalidExpiryDate: 'La fecha de vencimiento no es válida',
                    emptyCVC: 'Ingresá el Código de Seguridad',
                    invalidCVC: 'Código de seguridad inválido',
                }
            });
                
        try{
            rebill_checkout.setStyles({
                card_form: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: 'none',
                },
                button: {
                    base: {
                        marginTop: '30px',
                        alignSelf: 'center',
                        width: 150,
                        height: 35,
                        color: 'white',
                        backgroundColor: '#353FDF',
                        fontFamily: 'unset',
                        fontSize: 13,
                    },
                    logo: false,
                },
                fieldWrapper: {
                    base: {
                        display: 'flex',
                        display: 'inherit',
                        fontSize: 13,
                        width: this.state.rebillSdk.width,
                    },
                },
                inputWrapper: {
                    base: {
                        flex: 1,
                        height: 36,
                        width: this.state.rebillSdk.width,
                    },
                },
                input: {
                    base: {
                        backgroundColor: 'white',
                        width: this.state.rebillSdk.width,
                    },
                    cardNumber: { flex: 2, fontSize: 13 },
                    expiryDate: { flex: 1, fontSize: 13, placeholder: 'MM/AA' },
                    cvc: { flex: 1 },
                },
                errorText: {
                    base: { textAlign: 'center' },
                },
            });

            rebill_checkout.setElements("rebill_elements_1");
            this.setState({loadingSdk: true})
            const element = document.getElementById("rebill_elements_1").children[0];
            element.style.width= this.state.rebillSdk.width;
            element.style.height='400px';
            element.style.padding='0px';
            
        } catch(error){
            console.log("Error")
            console.log(error)
            
        }
    
    }


    componentDidMount() {
        // REBILL SDK CONFIG
        let customObj = {}
        if (isMobile){
            customObj = {
                width: '95%',
                iframeWidth: '95%',
                workerImg: '140px',
                cardHeight: '100%'
            }
            this.setState({rebillSdk: customObj})
        }else{
            customObj = {
                width: '100%',
                iframeWidth: '100%',
                workerImg: '280px',
                cardHeight: '550px'
            }
            this.setState({rebillSdk: customObj})
        }
        // 

        window.Mercadopago.setPublishableKey("APP_USR-59fb9280-bf19-4e97-945b-8e4dc2b10c99");
        window.Mercadopago.getIdentificationTypes((status, getIdTypes) => {
            this.setState({ documentTypes: getIdTypes, loading: false })
        }
        );
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/planes/' + this.props.plan_id,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        // console.log("PLANESSS")
                        // console.log(response)
                        this.setState({ loadingPlans: false, plan: response, loading:false })
                    })
                    .catch(err => {
                        message.error('Error leyendo tabla de planes')
                        this.setState({ loadingPlans: false })
                    })
            })
    }

    componentWillUnmount() {
        if (interval !== null) {
            clearInterval(interval)
        }
    }

    handleSubmit(event) {
        event.preventDefault()
        this.getCardToken()

    }

    handleChange(field, value) {
        let newData = { ...this.state.formData }
        newData[field] = value
        this.setState({ formData: newData })
        switch (field) {
            case 'cardNumber':
                if (value === null) {
                    break;
                } else {
                    this.guessPaymentMethod(value)
                    break;
                }
            case 'docType':
                let docData = this.state.documentTypes.filter(type => type.id === value)[0]
                this.setState({ docMinLength: docData.min_length, docMaxLength: docData.max_length })
                break;
            default:
                break;
        }
    }

    guessPaymentMethod(card) {

        let cardnumber = card.toString().replace(/\W/g, "");
        if (cardnumber.length >= 6) {
            let bin = cardnumber.substring(0, 6);
            window.Mercadopago.getPaymentMethod({
                "bin": bin
            }, this.setPaymentMethod);
        }
    }

    getReferenceNumber(ticket_link){
        const searchParams = new URLSearchParams(ticket_link)
        let paymentId = searchParams.get('payment_id')

        return paymentId
    }

    call_api() {
        this.setState({ loading: true })
        Auth.currentSession()
            .then(session => {
                API.post(
                    'test',
                    '/payment',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: {
                            card_token: this.state.card.value,
                            transaction_amount: this.state.plan.costo,
                            installments: this.state.formData.insstallments,
                            payment_method_id: this.state.formData.paymentMethodId,
                            payment_method: this.state.formData.paymentMethod,//credit_card, debit_card, ticket
                            payer_email: this.state.formData.paymentMethod === 'ticket' ? this.props.login.user_data.email : this.state.formData.email,
                            plan_id: this.state.plan.planId,
                            plan_month: this.state.plan.plazo,
                            first_name: this.props.login.user_data.nombre,
                            last_name: this.props.login.user_data.apellido,
                            payer_id_number: this.state.formData.docNumber,
                            payer_id_type: this.state.formData.docType,
                            mp_customer_id: this.props.login.user_data.mp_customer_id === (null || undefined) ? null : this.props.login.user_data.mp_customer_id,
                            customer_email: this.props.login.user_data.email,
                            customer_cuit: this.props.login.user_data.cuit,
                            plan: this.state.plan.plan
                        }
                    }
                )
                    .then(response => {
                        this.setState({ paymentResponse: response })
                        
                        if (response.payment_id === 'ERROR' || response['msg'] ==='Payment not creted') {
                            message.error("No se pudo generar el pago, reintenta con otro medio")
                            this.setState({ loading: false })

                        } else if (this.state.formData.paymentMethod === 'ticket') {
                            if (response['ticket_link']=== undefined || response['ticket_link']=== null ){
                                message.error('No se pudo generar el ticket de pago. Reintenta con otro medio')
                            } else{

                            let refNum = this.getReferenceNumber(response.ticket_link)
                            /*window.open(response['ticket_link'], '_blank')*/
                            let state = this.props.login.user_data
                            state['estado_pago']='PAGO_EN_PROCESO'
                            state['plan_id']=this.state.plan.planId
                            this.props.UserDataLoad(state)
                            this.props.getPaymentNumber(refNum, this.state.formData.paymentMethodId)
                            /*this.props.history.push('/')*/
                            }}
                        else {
                            interval = setInterval(this.handleResponse, 4000, response)
                        }

                    })
                    .catch(err => {
                            // console.log(err)
                            message.error("Ocurrió un error generando el pago")
                            this.setState({ loading: false })
                            this.props.history.push('/')
                    })
            })
            .catch(err => {
                message.error("Error obteniendo credenciales de usuario")
            })
    }


    setPaymentMethod(status, response) {
        if (status === 200) {
            let paymentMethod = response[0];
            this.setState({ mpResponse: paymentMethod })

            if (paymentMethod.additional_info_needed.includes("issuer_id")) {
                this.setState({ issuerRequired: true })
                this.getIssuers(paymentMethod.id)
            }
        } else {
            message.error(`Error en medio de pago: ${response}`);

        }
    }

    getIssuers(paymentMethodId) {

        window.Mercadopago.getIssuers(paymentMethodId, this.setIssuers)
    }

    setIssuers(status, response) {

        if (status === 200) {
            this.setState({ issuerOptions: response })
        }
        else {
            message.error(`Error obteniendo lista de bancos: ${response}`);
        };
    }

    getCardToken(event) {
        if (!this.state.doSubmit) {
            let $form = this.state.formData;
            window.Mercadopago.createToken($form, this.setCardTokenAndPay);
            return false;
        }
    }

    setCardTokenAndPay(status, response) {
        if (status === 200 || status === 201) {
            let cardToken = { ...this.state.card }
            cardToken['value'] = response.id
            let paymentMethodData = { ...this.state.formData }
            paymentMethodData['paymentMethod'] = this.state.mpResponse.payment_type_id
            paymentMethodData['paymentMethodId'] = this.state.mpResponse.id
            this.setState({ card: cardToken, formData: paymentMethodData })
            this.call_api()
        } else {

            switch (response.cause[0].code) {
                case 'E301':
                    message.error('Número de tarjeta inválido')
                    break
                case 'E302':
                    message.error('Revisa tu código de seguridad')
                    break
                case '316':
                    message.error('Nombre inválido!')
                    break
                case '322':
                    message.error('Tipo de documento inválido')
                    break
                case '323':
                    message.error('Revisa tu documento')
                    break
                case '324':
                    message.error('El documento es inválido')
                    break;
                case '325':
                    message.error('Mes de vencimiento inválido')
                    break;
                case '326':
                    message.error('Año de vencimiento inválido')
                    break;
                default:
                    message.error('Revisa los datos ingresados')
                    break;

            };
        }
    }

    updatePaymentId(entidad) {
        let aux = { ...this.state.formData }
        aux['paymentMethod'] = 'ticket'
        aux['paymentMethodId'] = entidad
        this.setState({ formData: aux })
        this.call_api()
    }

    changePaymentMethod() {
        if (this.props.stepsUser) {
            this.props.history.push('/initial-plan/2')
        }
        else {
            this.props.history.push('/mejorar-plan')
        }
    }

    handleSubmitForm = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
            const step = this.state.current
            this.setState({ current : step + 1 })
            this.scriptLoaded(values)
            // console.log('Received values of form: ', values);
          }
        });
      };

    render() {
        const {current}  = this.state;
        const { getFieldDecorator} = this.props.form;
        
        const documentNumberValidator = (rule, value, callback) => {
            if (value === null){
                callback()
            }
            if (isNaN(value.toString())) {
                callback("DNI invalido")
            }
            else {
                if (this.state.docMinLength <= value.toString().length && value.toString().length <= this.state.docMaxLength) {
                    const newCardHolder = this.state.cardHolder
                    newCardHolder.identification.value = value
                    this.setState({cardHolder : newCardHolder })
                    callback()

                } else {
                    callback('DNI incorrecto')

                }
            }
        }
    
        const steps = [
            {
                title: 'Datos de Pago',
                icon: <Icon type="solution" />,
                content: 
                        <>
                        <Row style={{marginTop: 50}}>
                            <Form hideRequiredMark={false} onSubmit={this.handleSubmitForm}>
                                <Row gutter={10}>
                                    {/* <h2> Datos del titular</h2> */}
                                    <p></p>
                                    <Row lg={6}>
                                        <Form.Item 
                                            label={'Nombre y Apellido'}
                                            >
                                            {
                                                getFieldDecorator('cardholderName', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingresá tu nombre'
                                                    }],
                                                    value: this.state.formData.cardholderName
                                                })(
                                                    <Input
                                                        style={{"height" : "28px"}}
                                                        // disabled={false}
                                                        type= 'cardholderName'
                                                        placeholder={'Como figura en tu tarjeta'}
                                                        onChange={(e) => this.handleChange("cardholderName", e.target.value ? e.target.value : null)}
                                                        prefix= {<Icon type="user" style={{ color: '#d8d8d8' }} />}
                                                    />
                                                )
                                            }
                                        </Form.Item>
                                    </Row>
        
                                    <Row lg={6}> 
                                        <Form.Item label={'Tipo de Documento'} >
                                            {
                                                getFieldDecorator('docType', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Campo requerido',
                                                        },
                                                    ],
                                                    value: this.state.formData.docType,
                                                    initialValue: 'DNI',
                                                })(
                                                    <Select
                                                
                                                        style={{ width: '100%' , heigth : '28px'}}
                                                        placeholder={'Tipo de documento'}
                                                        onChange={(value) => this.handleChange("docType", value ? value : null)}
                                                        // disabled={false}
                                                    >
                                                        {this.state.documentTypes.map(docs => {
                                                            return <Option key={docs.id} id={docs.id}>{docs.name}</Option>
                                                        })}
                                                    </Select>
                                                )
                                            }
                                        </Form.Item>
                                    </Row>
        
                                    <Row lg={6}>
                                        <Form.Item label={'Número de Documento'} >
                                            {
                                                getFieldDecorator('docNumber', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Número de documento inválido'
                                                        },
                                                        {
                                                            validator: documentNumberValidator
                                                        }
                                                    ],
                                                    value: this.state.formData.docNumber,
                                                    initialValue: null,
                                                })(
                                                    <Input
                                                        type='docNumber'
                                                        style={{ width: '100%' , height : '28px'}}
                                                        placeholder={'Número de documento del titular'}
                                                        onChange={(e) => this.handleChange("docNumber", e.target.value ? e.target.value : null)}
                                                        disabled={false}
                                                        prefix= {<Icon type="idcard" style={{ color: '#d8d8d8' }} />}
                                                    />
                                                )
                                            }
                                        </Form.Item>
                                    </Row>
                                </Row>
                                <Row style={{marginTop: 10, marginBottom: 10}}>
                                    <Col align='center' style={{ marginBottom: 10}}>
                                        <Button style={{background: '#353FDF'}} htmlType='submit' type="primary" loading={this.state.loading}>
                                            Siguiente
                                        </Button>
                                    </Col>
                                    <Col align='center' >
                                    <Row>
                                        <Button type="ghost" onClick={() => this.changePaymentMethod()} disabled={false}> Cambiar medio de pago</Button> 
                                    </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Row>  
                        </>
            },
            {
                title: 'Pago',
                icon: <Icon type="shopping-cart" /> ,
                status: 'wait',
                content: 
                    
                    <Row >
                        <Col style={{marginBottom:0}}/>
                        <Row style={{marginBottom:5}}> 
                            <Divider>Datos de la tarjeta  </Divider>
                            <Col align='center'>
                                <p>
                                    Ingresa número de tarjeta, vencimiento y código de seguridad
                                </p>
                            </Col>
                        </Row>
                        <Row justify='space-between'>
                            <Col align= 'center' type='flex'>
                                {!this.state.loadingSdk &&
                                    <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                                        <Col style={{minHeight:'360px'}}>
                                            <Spin/>
                                        </Col>
                                    </Row>
                                }
                                <center>
                                    <div id = "rebill_elements_1" /> 
                                </center>                                
                            </Col>
                        </Row>                        
                        <Row>
                            <Divider>
                                <Icon type="lock" />
                            </Divider>
                            <Col align='center'>
                                <img alt="mpago" src={mpago} className="mpago" style={{ height: "80px", marginTop: "-4px", marginBottom: "15px"}} />
                            </Col>
                        </Row>
                        <Col align='center'>
                            <Button style={{width:'135px'}} onClick={() => this.prev()} disabled={this.state.loading}>
                                Anterior
                            </Button>
                        </Col>
                    </Row> 

            }
        ]
        
        if (this.state.loading) {
            return (
                <>
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                    <Col style={{minHeight:'360px'}}>
                        <Spin indicator={CustomSpinner}/>
                    </Col>
                </Row>
                <Row></Row>
                </>)
        }
        else
            if (this.state.plan.medio === 'Otros') {

                return (
                    <>
                        <Paragraph >Selecciona una entidad para generar un ticket de pago en efectivo. </Paragraph>
                        <br />
                        <Radio.Group 
                            onChange={(e) => this.updatePaymentId(e.target.value)}
                            buttonStyle='solid'
                            optionType='button'
                            style={{ width: '100%' }}
                        >
                            <Row gutter={[10, 5]} type='flex' justify='center'>

                                <Col lg={6} xs={24}>
                                    <Card>
                                        <center><img alt="rapipago" src={RapiPago} className="rapipago" style={{ height: "80px", marginTop: "15px", marginBottom: "15px" }} /></center>
                                        <br></br>
                                        <center><RadioButton value={"rapipago"}>RapiPago</RadioButton></center>
                                    </Card>
                                </Col>
                                <Col lg={6} xs={24}>
                                    <Card>
                                        <center><img alt="pagofacil" src={PagoFacil} className="pagofacil" style={{ height: "80px", marginTop: "15px", marginBottom: "15px" }} /></center>
                                        <br></br>
                                        <center><RadioButton value={"pagofacil"}>Pago Facil</RadioButton></center>
                                    </Card>
                                </Col>
                            </Row>
                        </Radio.Group>
                        <Row>
                            <Col span={12} offset={6}>
                                <Button align="middle" style={{marginTop:"5vh"}} onClick={() => this.changePaymentMethod()}>Cambiar medio de Pago</Button>
                            </Col> 
                        </Row>
                    </>)

            }
            else
                if (this.state.plan.medio === 'Tarjeta') {

                    return (
                            <Row gutter={[8, 8]}>
                                <Col lg={12}>
                                    <Card style={{height: this.state.rebillSdk.cardHeight}}>
                                        <center>
                                            <img alt="checkout" src={Checkout} className="checkout" style={{ height: this.state.rebillSdk.workerImg, marginTop: "15px", marginBottom: "15px" }} />
                                            <h1>
                                                {/* sumar un punto en el h1 */}
                                                <b>
                                                ¡Ya casi!
                                                </b>
                                            </h1>
                                            <p>
                                                Estás a un paso de convertirte en trabajador independiente
                                            </p>
                                            <p>
                                                Después de realizar el pago uno de nuestros analistas finalizará tu alta y configuración de cuenta.
                                            </p>
                                            { this.state.plan.plazo === 1 &&
                                                <Text strong style={{fontSize:'15px'}}>
                                                    Seleccionaste: Plan {this.state.plan.plan} por 1 mes - ${this.state.plan.costo}
                                                </Text>
                                            }
                                            { this.state.plan.plazo !== 1 &&
                                                <Text strong>
                                                    Seleccionaste: Plan {this.state.plan.plan} por {this.state.plan.plazo} meses - ${this.state.plan.costo}    
                                                </Text>}
                                        </center>
                                    </Card>
                                </Col>
                                <Col lg={12} align='left'>
                                        <Card  bodyStyle={{padding: "15px" }} className='card_checkout'
                                            style={{ marginBottom: 10 ,height:this.state.rebillSdk.cardHeight }}
                                        >
                                            <Steps current={current} labelPlacement='vertical' style={{marginBottom: 5}} >
                                                {steps.map(item => (
                                                    <Step key={item.title} description={item.title} icon={item.icon} />
                                                    ))}
                                            </Steps>
                                            <div className="steps-content">{steps[current].content}</div>
                                            {/*  */}
                                            <div className="steps-action">
                                            {/*  */}
                                            </div>
                                        </Card>
                                </Col>
                            </Row>
                    )
                } else { return null }
    }
}
const paymentComponent = Form.create({ name: 'paymentForm' })(MercadoPago)
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(paymentComponent));
